module.exports = __webpack_public_path__ + "static/media/HorizontalBottomAdPreview.ade3c98f.svg";